export default function TeamSection() {
  const team = [
    {
      name: 'Ana Pavelski',
      role: 'Sócia - Expertise em Administração Pública',
      image: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/56b13c32251368d6227c87c5b81be98f.jpeg',
      bio: 'Mais de 10 anos de experiência na Administração Pública, com vivência nos processos internos'
    },
    {
      name: 'Carolina Sequinel',
      role: 'Sócia - Expertise Jurídica',
      image: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/c2cb4acc35d8c9502b236362fde97336.png',
      bio: 'Advogada especialista em licitações e contratos, responsável pela segurança jurídica, defesas e impugnações.'
    },
    {
      name: 'Carol Pavelski',
      role: 'Sócia - Gestão Operacional',
      image: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/113af467c07beebe7f3c00c74c421f3c.jpeg',
      bio: 'Especialista em documentação e regularidade fiscal, cuidando de cada detalhe do cadastro e habilitação da sua empresa.'
    }
  ];

  return (
    <section id="team" className="py-20 bg-light-grey">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Quem Somos
          </h2>
          <p className="text-lg text-text-grey max-w-3xl mx-auto">
            Uma equipe multidisciplinar unindo Direito, Administração Pública e Gestão Operacional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {team.map((member, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="w-full h-80 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-primary mb-2">
                  {member.name}
                </h3>
                <p className="text-accent font-medium mb-4">
                  {member.role}
                </p>
                <p className="text-text-grey text-sm leading-relaxed">
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}